import { OreHero } from '@edenredespana/oreneta'
import { ReactNode, CSSProperties } from 'react'

interface IPageWrapperProps {
  children: ReactNode
  title?: string
  paddingSmaller?: boolean
  subtitle?: string | JSX.Element
  titleSize?: 'title-lg' | 'title-md'
  paddingTop?: number
  style?: CSSProperties
}

export const PageWrapper = ({
  children,
  title,
  subtitle,
  titleSize,
  paddingSmaller,
  paddingTop,
  style,
}: IPageWrapperProps): JSX.Element => {
  const wrapperStyle: CSSProperties | undefined =
    paddingTop !== undefined || style
      ? { ...(style || {}), ...(paddingTop !== undefined ? { paddingTop } : {}) }
      : undefined
  return (
    <div
      className={`page-wrapper ${paddingSmaller ? 'page-wrapper--smaller' : ''} ${title ? 'page-wrapper--has-hero' : ''}`}
      style={wrapperStyle}
    >
      {title ? <OreHero title={title} subtitle={subtitle} titleSize={titleSize} /> : null}
      {children}
    </div>
  )
}

export default PageWrapper
